































































import {
  defineComponent,
  Ref,
  ref,
  useFetch,
  computed,
  useContext,
} from '@nuxtjs/composition-api';
import { SfImage } from '~/components/StorefrontUi';
import ProductCategoriesAccordion from '~/modules/catalog/category/components/filters/ProductCategoriesAccordion.vue';

import { useUiHelpers } from '~/composables';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import { addBasePath } from '~/helpers/addBasePath';
import type { Aggregation } from '~/modules/GraphQL/types';
import { findActiveCategory } from '~/modules/catalog/category/helpers/findActiveCategory';
import type { SelectedFiltersInterface } from './useFilters';

export interface UseFiltersProviderInterface {
  selectedFilters: Ref<SelectedFiltersInterface>;
  filters: Ref<Aggregation[]>;
}

export default defineComponent({
  name: 'CategoryFilters',
  components: {
    SfImage,
    CategorySubChildFilters: () => import(
      '~/modules/catalog/category/components/filters/CategorySubChildFilters.vue'
    ),
    ProductCategoriesAccordion,
  },
  setup() {
    const { activeCategory, categoryAncestors, categoryTree } = useTraverseCategory();
    const { getCatLink } = useUiHelpers();
    const curentSubChildUid = ref('');
    const { env } = useContext();
    const categoryAncestorsUids = computed(() => categoryAncestors.value.map((item) => item.uid));
    const categoryParent = computed(
      () => categoryAncestors.value[categoryAncestors.value.length - 2],
    );
    const dropdownCategories = computed(
      () => activeCategory.value?.children || categoryParent.value?.children || [],
    );
    const toggleSubChildCategories = (uid: string) => {
      curentSubChildUid.value = curentSubChildUid.value === uid ? '' : uid;
    };
    const checkIsCategoryActive = (uid: string) => activeCategory.value?.uid === uid
      || categoryAncestorsUids.value.includes(uid);

    useFetch(async () => {
      if (categoryAncestors.value.length > 2) {
        curentSubChildUid.value = categoryAncestors.value[1].uid;
      }
    });

    const categoryTreeNavigation = computed(() => {
      const mainCategoryUid = env.VSF_MAGENTO_MAIN_CATEGORY_UID;
      return categoryTree.value === null
        ? null
        : findActiveCategory(
          categoryTree.value,
          mainCategoryUid as string,
          'uid',
        );
    });

    return {
      categoryTreeNavigation,
      categoryTree,
      categoryParent,
      curentSubChildUid,
      toggleSubChildCategories,
      addBasePath,
      getCatLink,
      activeCategory,
      checkIsCategoryActive,
      dropdownCategories,
      categoryAncestorsUids,
    };
  },
});
